module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.71394c0c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/stroke7/fonts/Pe-icon-7-stroke.eot
// module id = 2220
// module chunks = 228